
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";


// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCv_bRBHp7exxGN7L3UTw2XQ38tV_qNeP8",
  authDomain: "asian-polytechnic-campus.firebaseapp.com",
  projectId: "asian-polytechnic-campus",
  storageBucket: "asian-polytechnic-campus.firebasestorage.app",
  messagingSenderId: "92559984748",
  appId: "1:92559984748:web:9e39dc098f2f1e14d47049"
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export













